import "../scss/base_rem.scss";
import "../scss/main_rem.scss";
import $ from "./jq";
import VideoBlock  from "./VideoBlock"
import scroll from './scroll'
// import {entryShow} from "./entry";

import "./header";


// entryShow();
let videoBlock = new VideoBlock();
videoBlock.init();
scroll.init()
let lastOffset = window.scrollY;

(function(){
    let frame_el = document.createElement("iframe");
    frame_el.onload = function(){
        $(".j-headBg").addClass("hide");
        $(".j-bgVdeo").removeClass("hide");
        document.body.removeChild(frame_el)
    }
    document.body.appendChild(frame_el)
    frame_el.src =  "https://www.youtube.com/embed/he1YsIs-VYI?rel=0&loop=1&autoplay=1&controls=0&playlist=he1YsIs-VYI";
    frame_el.className = "hide";
})()